import { capitalize } from 'lodash';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import InitiativeFormContainer from '../../containers/initiatives/InitiativeFormContainer.jsx';

const EditInitiative = ({ initiativeId, initiativeType, query, slug }) => {
  const title = `Edit ${capitalize(initiativeType)}`;

  return (
    <>
      <Helmet>
        <title>{title} | ChangeSync</title>
      </Helmet>
      <InitiativeFormContainer
        query={query}
        slug={slug}
        title={title}
        initiativeId={initiativeId}
        initiativeType={initiativeType}
      />
    </>
  );
};

EditInitiative.getInitialProps = ({ query }) => ({
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
  slug: query.slug,
  query: {
    draftId: query.draftId,
  },
});

export default requireAuth(withRouterParams(EditInitiative));
